const formatter = new Intl.NumberFormat(
  "de-DE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }
);

export default function (val, unit) {
  let value = val;
  if (value !== null) {
    value = formatter.format(value);

    if (unit) {
      value += `\u00a0 ${unit}`;
    }

    return value;
  }

  return "";
}
